import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from "@angular/core";
import { ApiService } from "src/app/core/services/shared/api.service";
import { GlobalVarService } from "src/app/core/services/shared/global-var.service";
import { Searchconfig } from "virtue-form";

export interface IntrestPageAnswer {
  defaultValue: string;
  defaultLabel: string;
  list: Array<any>;
}

export interface CollegeName {
  key: string;
  value: string;
  stateCode: String;
}
@Component({
  selector: "app-autocomplete-search-box",
  templateUrl: "./autocomplete-search-box.component.html",
  styleUrls: ["./autocomplete-search-box.component.scss"],
})
export class AutocompleteSearchBoxComponent implements OnInit {
  modelvalue: Array<CollegeName> = [];
  collegeSearchList: any;
  @Input() options: any;
  @Input() disabledOption: Map<string, string>;
  @Input() pageAnswer: Map<string, IntrestPageAnswer> = new Map();
  @Input() optionsList: Array<any> = [];

  collegeRepeat: Array<any>=[];
  @Input("index") index: string;
  selectValue: string = "";
  interestPageAnswerMap: Map<string, IntrestPageAnswer> = new Map();
  universitySelectedValueMap: Map<string, string> = new Map();
  @Output() selectChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() deletegettingvalue: EventEmitter<any> = new EventEmitter<any>();
  
  constructor(
    public apiService: ApiService,
    public globalvar: GlobalVarService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    if (this.pageAnswer.size > 0) {
      this.getDefaultValuesFromAnswerMap();
    }
  }

  onChangeSearch(val: Searchconfig) {}

  ngOnChanges() {
    if (this.pageAnswer.size > 0) {

       this.getDefaultValuesFromAnswerMap();
      let ansMap = this.pageAnswer.get(this.index);
      if (!ansMap || ansMap == undefined) {
        this.modelvalue = [];
      } else {
        if (ansMap.defaultValue != "") {
          //this.getDefaultValuesFromAnswerMap();
        }
      }
    }
  }

  onSelected(val: any) {
    // this.setUniversitySelectedValues("u_Selected" + this.index, val.key);
    // this.setInterestPageAnswer(this.index, val.key, this.collegeSearchList, "");

    let obj = {
      ipedsId: val.key,
      list: this.collegeSearchList,
      defaultLabel: val.value,
    };

    if (this.globalvar.isSelectionByFilters == true) {
      this.globalvar.isSelectionByFilters = false;
      this.globalvar.handleSelectionCollege = true;
    }

    if (this.globalvar.isSelectionByFilters == false && this.globalvar.handleSelectionCollege == false) {
      
      this.globalvar.handleSelectionCollege = true;
    }

    this.selectChange.emit(obj);
  }

  setUniversitySelectedValues(index: string, value: string) {
    this.universitySelectedValueMap.set(index, value);
    this.universitySelectedValueMap = new Map(this.universitySelectedValueMap);
    this.globalvar.universitySelectedValueMap = this.universitySelectedValueMap;
  }

  getDefaultValuesFromAnswerMap() {
    if (this.pageAnswer) {
      // this.interestPageAnswerMap = new Map(
      //   this.globalvar.interestPageAnswerMap
      // );
      let ansMap = this.pageAnswer.get(this.index);
      if (ansMap != undefined) {
        // let ansMap = this.interestPageAnswerMap.get(this.index);
        this.collegeSearchList = ansMap.list;
        let filterCollegeList = [];
        this.collegeSearchList.forEach((elem) => {
          // const ar = ansMap.defaultValue;

          if (
            (elem.key != undefined && ansMap.defaultValue == elem.key) ||
            (elem.ipedsId != undefined && ansMap.defaultValue == elem.ipedsId)
          ) {
            let data = {};
            if (elem.key != undefined) {
              data = {
                key: elem.key,
                value: elem.value,
                stateCode: elem.stateCode,
              };
              if (this.modelvalue != elem.value) {
                this.modelvalue = elem.value;


                if((this.globalvar.isSelectionByFilters == false) && (this.globalvar.handleSelectionCollege == false))
                // if (this.globalvar.handleSelectionCollege == false) 
                {
                  let obj = {
                    ipedsId: ansMap.defaultValue,
                    list: ansMap.list,
                  };

                  if (ansMap?.defaultLabel == "") {
                    this.selectChange.emit(obj);
                  }
                }
              }
            } else {
              data = {
                key: elem.ipedsId,
                value: elem.collegeName,
                stateCode: elem.stateCode,
              };

              if (this.modelvalue != elem.collegeName) {
                this.modelvalue = elem.collegeName;

                if((this.globalvar.isSelectionByFilters == false) && (this.globalvar.handleSelectionCollege == false))
                {
                // if (this.globalvar.handleSelectionCollege == false) {
                  let obj = {
                    ipedsId: ansMap.defaultValue,
                    list: ansMap.list,
                  };
                  this.selectChange.emit(obj);
                }
              }
            }

            //  filterCollegeList.push(data as any);
          }
        });
        // this.modelvalue = filterCollegeList;
      }
    }
  }

  setInterestPageAnswer(
    index: string,
    selectedValue: string,
    list: any,
    selectedLabel: any
  ) {
    let ans = {
      defaultLabel: selectedLabel,
      defaultValue: selectedValue,
      list: list,
    };
    this.interestPageAnswerMap.set(index, ans);
    this.interestPageAnswerMap = new Map(this.interestPageAnswerMap);
    this.globalvar.interestPageAnswerMap = this.interestPageAnswerMap;
  }

  replaceChar() {
    return;
  }

  // getAutoSearchData(search: string) {
  //   // this.searchedClgList=[];
  //   let data = {
  //     name: search,
  //   };

  //   this.apiService.searchCollegeName(data).then((res) => {
  //     let searchObj = res;
  //     let searchclgList = [];
  //     Object.keys(searchObj).forEach((key) => {
  //       if (searchObj[key].matchedAgainst != null) {
  //         let obj = {
  //           key: searchObj[key].matchedAgainst.ipedsId,
  //           value: searchObj[key].matchedAgainst.name,
  //           stateCode: searchObj[key].matchedAgainst.stateCode,
  //         };
  //         searchclgList.push(obj);
  //       }
  //     });
  //     this.collegeSearchList = searchclgList;
  //   });

  //   // }, 500);
  // }

  getAutoSearchData(search: string) {
    // this.searchedClgList=[];
    if(search==''){
      this.deletegettingvalue.emit(search)
    }
    this.collegeRepeat = this.globalvar.selectedUniversityList;
      let data = {
        name: search,
      };
      this.apiService.searchCollegeName(data).then((res) => {
        let searchObj = res;
        let searchclgList = [];
        Object.keys(searchObj).forEach((key)=> {
          if (searchObj[key].matchedAgainst != null) {
            let obj = {
              key: searchObj[key].matchedAgainst.ipedsId,
              value: searchObj[key].matchedAgainst.name,
              stateCode: searchObj[key].matchedAgainst.stateCode,
            };
            if(this.collegeRepeat.length == 0 ){
              searchclgList.push(obj);
          }
          else{ 
               if(this.collegeRepeat.find((element:any)=>element?.ipedsId == obj.key)){
               }
               else{
              searchclgList.push(obj);
               }
          }
           
          }
        });
        this.collegeSearchList = searchclgList;
      });
     } 
}
